import { render, staticRenderFns } from "./BecTransferPart1.vue?vue&type=template&id=58ae56be&"
import script from "./BecTransferPart1.vue?vue&type=script&lang=js&"
export * from "./BecTransferPart1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports